export default function NotFound() {
  return (
    <div className="flex dark:bg-gray-700 dark:text-white w-full h-full items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 400 300"
        width="406"
        height="306"
      >
        <path
          d="M95.85,121.73c-27.66,4.91-47.21,29-44,55.43,1.71,14,8.64,26.43,26.47,30,47.3,9.51,225.85,45.31,260.93-16.72,27.35-48.34,11.05-81.81-14.35-102.76s-78-16.6-121.53-2.26C171,96.11,146.93,112.65,95.85,121.73Z"
          fill="#e6e6e6"
          opacity="0.3"
        />
        <ellipse
          cx="205.6"
          cy="245.02"
          rx="161.02"
          ry="11.9"
          fill="#e6e6e6"
          opacity="0.45"
        />
        <circle cx="115.32" cy="60.66" r="19.14" fill="#ffd200" />
        <circle
          cx="115.32"
          cy="60.66"
          r="36.49"
          fill="#ffd200"
          opacity="0.15"
        />
        <circle cx="195.69" cy="193.3" r="51.17" fill="#24285b" />
        <circle cx="195.69" cy="193.3" r="32.21" fill="#fff" />
        <path
          d="M133.91,205.51c3.39,0,4.61,1.22,4.61,4.6v5.83c0,3.39-1,4.61-4.61,4.61h-9.35V238.3c0,3.38-1.22,4.6-4.61,4.6h-6.64c-3.38,0-4.6-1.22-4.6-4.6V220.55H64c-3.38,0-4.6-1.22-4.6-4.61v-4.88A9,9,0,0,1,61,205.51l45-55.83a8.07,8.07,0,0,1,6.5-3.25H120c3.39,0,4.61.95,4.61,4.61v54.47Zm-25.2-36.32L79.3,205.51h29.41Z"
          fill="#68e1fd"
        />
        <path
          d="M327.42,205.51c3.39,0,4.61,1.22,4.61,4.6v5.83c0,3.39-.95,4.61-4.61,4.61h-9.35V238.3c0,3.38-1.22,4.6-4.61,4.6h-6.64c-3.38,0-4.6-1.22-4.6-4.6V220.55H257.5c-3.38,0-4.6-1.22-4.6-4.61v-4.88a9,9,0,0,1,1.62-5.55l45-55.83a8.07,8.07,0,0,1,6.5-3.25h7.45c3.39,0,4.61.95,4.61,4.61v54.47Zm-25.2-36.32-29.41,36.32h29.41Z"
          fill="#68e1fd"
        />
        <path
          d="M307.35,135.53s-8.51-2.32-10.36-10.25c0,0,13.19-2.66,13.57,10.95Z"
          fill="#68e1fd"
          opacity="0.58"
        />
        <path
          d="M308.4,134.69s-5.95-9.41-.72-18.2c0,0,10,6.37,5.58,18.22Z"
          fill="#68e1fd"
          opacity="0.73"
        />
        <path
          d="M309.93,134.7s3.14-9.94,12.65-11.82c0,0,1.78,6.45-6.16,11.84Z"
          fill="#68e1fd"
        />
        <polygon
          points="303.76 134.47 305.48 146.28 316.35 146.33 317.95 134.53 303.76 134.47"
          fill="#24285b"
        />
        <path
          d="M201.88,126.11s1.4,6.75.79,11.43a3.46,3.46,0,0,1-3.91,3c-2.35-.34-5.43-1.48-6.62-5l-2.76-5.75a6.21,6.21,0,0,1,1.93-6.9C194.85,119.63,201.23,122,201.88,126.11Z"
          fill="#f4a28c"
        />
        <polygon
          points="189.88 130.8 188.98 153.41 201.47 153.01 197.11 136.72 189.88 130.8"
          fill="#f4a28c"
        />
        <path
          d="M200.21,126.59a27.36,27.36,0,0,1-6.37.27,5.76,5.76,0,0,1,.74,6.27,4.68,4.68,0,0,1-5.4,2.52l-.93-8.82a7,7,0,0,1,2.8-6.64,24.34,24.34,0,0,1,2.77-1.79c2.41-1.32,6.32-.07,8.39-2.05a1.67,1.67,0,0,1,2.75.78c.72,2.63.74,6.9-2.71,8.79A6.36,6.36,0,0,1,200.21,126.59Z"
          fill="#24285b"
        />
        <path
          d="M195.29,132.84s-.36-2.64-2.32-2.2-1.46,4.25,1.28,4.28Z"
          fill="#f4a28c"
        />
        <path
          d="M202.54,130.41l2.23,2.41a1.11,1.11,0,0,1-.49,1.81l-2.56.8Z"
          fill="#f4a28c"
        />
        <path
          d="M198.22,140.25a8.24,8.24,0,0,1-4.3-1.92s.66,4.09,5.66,7.61Z"
          fill="#ce8172"
          opacity="0.31"
        />
        <path
          d="M189,153.41l12.49-.4s19.62-3.33,26.43,12.67S226,204.29,226,204.29,218.9,228.16,189,225.52c0,0-24.87-1.44-27.68-35.53a33.25,33.25,0,0,0-.68-4.42C159.5,180.24,158.84,164.07,189,153.41Z"
          fill="#68e1fd"
        />
        <path
          d="M172.27,174.65s6.66.73,15.91,16.22,27.41,9.81,37.65-1.65l-19,25.14-21.28-1.71-11.57-30.8Z"
          opacity="0.08"
        />
        <rect
          x="242.24"
          y="139"
          width="3.69"
          height="10.74"
          transform="translate(-16.97 33.59) rotate(-7.61)"
          fill="#ffd200"
        />
        <rect
          x="242.24"
          y="139"
          width="3.69"
          height="10.74"
          transform="translate(-16.97 33.59) rotate(-7.61)"
          opacity="0.08"
        />
        <rect
          x="242.52"
          y="146.67"
          width="5.67"
          height="13.79"
          transform="translate(-18.17 33.84) rotate(-7.61)"
          fill="#24285b"
        />
        <path
          d="M240,116.77a12.1,12.1,0,1,0,13.6,10.39A12.1,12.1,0,0,0,240,116.77Zm2.74,20.46a8.55,8.55,0,1,1,7.33-9.6A8.56,8.56,0,0,1,242.78,137.23Z"
          fill="#ffd200"
        />
        <circle cx="241.67" cy="128.8" r="8.59" fill="#fff" />
        <path
          d="M161,176.33a6.18,6.18,0,0,1,11.25-1.68,141.62,141.62,0,0,1,12,24.39c7.15,19.06,42.21,6.49,55.15-37.95l7.38,4.59s-10.18,57.72-51.16,59.84c0,0-25.58,5.18-33.35-26.21,0,0-2-5.91-2.12-9.25l-.54-3.76a31.69,31.69,0,0,1,1.32-9.87Z"
          fill="#68e1fd"
        />
        <path
          d="M161,176.33a6.18,6.18,0,0,1,11.25-1.68,141.62,141.62,0,0,1,12,24.39c7.15,19.06,42.21,6.49,55.15-37.95l7.38,4.59s-10.18,57.72-51.16,59.84c0,0-25.58,5.18-33.35-26.21,0,0-2-5.91-2.12-9.25l-.54-3.76a31.69,31.69,0,0,1,1.32-9.87Z"
          fill="#fff"
          opacity="0.39"
        />
        <path
          d="M241.27,162.21s.75-9.51,4.67-9.49,13.13,7.06-1.09,11.71Z"
          fill="#f4a28c"
        />
        <path
          d="M343.49,89.6a6.76,6.76,0,0,0-6.76-6.76,6.59,6.59,0,0,0-1.09.09,9.1,9.1,0,0,0-8-4.8l-.33,0a10.82,10.82,0,1,0-21,0l-.33,0a9.12,9.12,0,1,0,0,18.23h31.63V96.3A6.77,6.77,0,0,0,343.49,89.6Z"
          fill="#e6e6e6"
        />
        <path
          d="M80.7,156.51a5.8,5.8,0,0,0-5.8-5.8,7,7,0,0,0-.93.08,7.81,7.81,0,0,0-6.89-4.11H66.8a9.28,9.28,0,1,0-18,0h-.28a7.82,7.82,0,1,0,0,15.63H75.65v-.05A5.81,5.81,0,0,0,80.7,156.51Z"
          fill="#e6e6e6"
        />
      </svg>
    </div>
  )
}
